import React from 'react'
import { Button, Container, TextBody, TextTitle } from '@pmi/pmi-iqos-ds-react'
import { htmlTranslation } from '@pmi/pmi-iqos-shared-react'
import QoinsTable from './points-table'

const ProfilePointsExpiring = ({
  translations,
  expiringData,
  showLoadMore,
  onLoadMoreClickHandler,
  isLoading
}) => {
  return (
    <Container py="8" px={['8', '8', '6']}>
      {expiringData && expiringData.length > 0 ? (
        <>
          <Container
            pb="8"
            display={Container.displays.flex}
            justifyContent={Container.justifyContentValues.center}>
            <TextTitle heading={TextTitle.headings.h4}>
              {translations.tk_tab3head}
            </TextTitle>
          </Container>
          <QoinsTable
            qoinsDataList={expiringData}
            getDate={expiring => expiring.expirationDate}
            getValueLabel={() =>
              htmlTranslation(translations, 'tk_tab3Status').value
            }
            getValue={expiring => expiring.qoinsToExpire}
          />
          {showLoadMore ? (
            <Container
              pt="8"
              display={Container.displays.flex}
              justifyContent={Container.justifyContentValues.center}>
              <Button
                disabled={isLoading}
                onClickHandler={onLoadMoreClickHandler}
                variant={Button.variants.secondary}
                text={translations.tk_loadMore}
                data-testing="ProfilePoints_Button_ExpiringLoadMore"
              />
            </Container>
          ) : null}
        </>
      ) : (
        <Container>
          <TextBody
            alignment={TextBody.alignments.center}
            {...htmlTranslation(translations, 'tk_noRecords')}
            data-testing="ProfilePoints_TextBody_ExpiringNoRecords"
          />
        </Container>
      )}
    </Container>
  )
}

export default ProfilePointsExpiring
